export function canSwitchMode(mode, minMode) {
    return minMode ? mode >= minMode : true;
}
//# sourceMappingURL=view-mode.js.map